import {
  CreateGUFStartRegistrationTask,
  EditGUFStartRegistrationTask,
} from "@nens/brostar/uploadapi-client";

import { addSchema } from "@/helpers/schema-utils";

import { pickGufPrimitiveLibraryFields } from "../guf-schema-primitive-library";

/**
 * Schema for LicensedQuantity within a GUF registration
 */
export const licensedQuantitySchema = addSchema<
  (
    | CreateGUFStartRegistrationTask
    | EditGUFStartRegistrationTask
  )["sourcedocumentData"]["licensedQuantities"]
>({
  type: "array",
  title: "Vergunde hoeveelheden",
  minItems: 0,
  items: {
    type: "object",
    title: "Vergunde hoeveelheid",
    required: ["licensedInOut"],
    properties: {
      ...pickGufPrimitiveLibraryFields([
        "licensedInOut",
        "maximumPerHour",
        "maximumPerDay",
        "maximumPerMonth",
        "maximumPerQuarter",
        "maximumPerYear",
      ]),
    },
  },
});
